module.exports = __webpack_public_path__ + "img/h-square.bdb6fb8f.svg";